import AgsControlList from "ags/controls/ags-control-list";
import GameiomPostFreespinLoopWins from "ags/states/post-freespin-loop-wins";
import axios from "axios";
import gameiomModel from "gameiom/model/gameiom-model";
import GameiomAutoplay from "gameiom/states/gameiom-autoplay";
import GameiomFreespinIdle from "gameiom/states/gameiom-freespin-idle";
import GameiomGameOver from "gameiom/states/gameiom-game-over";
import GameiomGameOverFreespins from "gameiom/states/gameiom-game-over-freespins";
import GameiomIdle from "gameiom/states/gameiom-idle";
import GameiomRecovery from "gameiom/states/gameiom-recovery";
import GameiomRequestFreespin from "gameiom/states/gameiom-request-freespin";
import GameiomRequestSpin from "gameiom/states/gameiom-request-spin";
import { UiDenomDisplayType } from "gameiom/wrapper/wrapper-data";
import * as queryString from "query-string";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import Loader from "slotworks/loader/loader";
import autoplayModel from "slotworks/model/autoplay/autoplay-model";
import BetModel from "slotworks/model/bets/bet-model";
import settingsModel from "slotworks/model/settings/settings-model";
import SettingsModel, { RealityMode } from "slotworks/model/settings/settings-model";
import CommsManager from "slotworks/server/comms-manager";
import { Services } from "slotworks/services/services";
import ControlList from "slotworks/smart-ui/control-list";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import Contract from "slotworks/utils/contracts/contract";

interface GameiomConfig {
    enableForcing: boolean;
    disclaimers: { [operatorId: string]: string };
}

class Gameiom {

    private gameiomConfig: GameiomConfig;

    public init() {

        this.setupStates();

        return new Contract<void>((resolve) => {
            this.loadGameiomConfig().then(() => {
                gameWrapper.gameLoadingStarted();

                gameiomModel.enableForcing = this.gameiomConfig.enableForcing;
                gameiomModel.language = "en-GB";
                gameiomModel.currency = "GBP";
                // gameiomModel.denomDisplay = "multiplier";
                SettingsModel.playMode = RealityMode.REAL;

                this.readQueryStringParams();

                this.setupPreloaderDisclaimer();
                this.setupStopOnFeatureJurisdiction();
/////////////////////////////////
///////////////////////////////////////////////
//////////////////////////
                resolve(null);
            });
        });
    }

    public initWrapper() {
        Components.preloader.onProgress.add((progress: number) => {
            gameWrapper.loadProgressUpdate(Math.round(progress * 100));
        });

        Services.sound.onMuteChange.add(() => {
            if (Services.sound.getMuted()) {
                gameWrapper.disableAudio();
            } else {
                gameWrapper.enableAudio();
            }
        });
    }

    public setProviderId(id: number) {
        gameiomModel.providerId = id;
    }

    public setupServices() {
        if (gameiomModel.currency === "TKN") {
            Services.currency.configure(gameiomModel.language, gameiomModel.currency, "symbol", true, null, true, true);
        } else {
            Services.currency.configure(gameiomModel.language, gameiomModel.currency, "symbol");
        }


        SettingsModel.setDisplayCredits(!gameiomModel.displayCurrency);

        BetModel.onCreditPerLineChanged.add(() => this.updateWrapperWithStake());
        BetModel.onCreditSizeChanged.add(() => this.updateWrapperWithStake());
    }

    public debugAuth(gameid: number = 1) {
        return new Contract<void>((resolve) => {
            gameiomModel.url = "wss://test-rgs.gameiom.com/platform";
            gameiomModel.username = "ags_test_21";
            gameiomModel.providerId = 48;
            gameiomModel.operatorId = 1;
            gameiomModel.gameId = gameid;
            gameiomModel.jurisdiction = "britain";
            gameiomModel.currency = "TKN";
            gameiomModel.disableFullscreen = false;
            gameiomModel.displayType = "currency";
            // gameiomModel.hideJackpotWording = true;
            // gameiomModel.minStopDuration = 17000;
            // Leave the autoplay here, autoplay from publiState is ignored, and should arrive from the wrapper.
            gameiomModel.autoplay = JSON.parse('{"numberOfRounds":{"defaultVal":20,"values":[20,40,80,100]},' +
                '"lossLimit":{"defaultVal":20000,"values":[5000,10000,20000,50000,100000], "lossLimitRequired":true},' +
                '"totalWinLimit":{"defaultVal":20000,"values":[5000,10000,20000,50000,100000]},"singleWinLimit":' +
                '{"defaultVal":5000,"values":[1000,5000,10000,20000,50000]}}');

            let query = "https://test-rgs.gameiom.com/rgs/rest/authenticate/playerlogin";
            query += "?username=" + gameiomModel.username;
            query += "&password=" + gameiomModel.username;
            query += "&gameId=" + gameiomModel.gameId;
            query += "&operatorId=" + gameiomModel.operatorId;
            query += "&jurisdiction=" + gameiomModel.jurisdiction;

            axios.get(query, {
                headers: {
                    gameProvider: gameiomModel.providerId
                }
            }).then((response: any) => {
                const data = response.data;
                gameiomModel.sessionToken = data.token;

                resolve(null);
            });
        });
    }
    public setupAgsControllerTypes() {
        if (gameiomModel.denomDisplay === UiDenomDisplayType.multiplier) {
            ControlList.CREDIT_SIZE_SLIDER.type = AgsControlList.AGS_CREDIT_SIZE_SLIDER.type;
            ControlList.CREDIT_SIZE_STEPPER.type = AgsControlList.AGS_CREDIT_SIZE_STEPPER.type;
        }
    }

    private setupStates() {
        StateRegister.add("gameiom-game-over", new GameiomGameOver(StateMachine));
        StateRegister.add("gameiom-game-over-freespins", new GameiomGameOverFreespins(StateMachine));
        StateRegister.add("gameiom-recovery", new GameiomRecovery(StateMachine));
        StateRegister.add("gameiom-autoplay", new GameiomAutoplay(StateMachine));
        StateRegister.add("gameiom-request-spin", new GameiomRequestSpin(StateMachine));
        StateRegister.add("gameiom-request-freespin", new GameiomRequestFreespin(StateMachine));
        StateRegister.add("gameiom-idle", new GameiomIdle(StateMachine));
        StateRegister.add("post-freespin-loop-wins", new GameiomPostFreespinLoopWins(StateMachine));
        StateRegister.add("gameiom-freespin-idle", new GameiomFreespinIdle(StateMachine));
    }

    private readQueryStringParams() {
        const params = queryString.parse(location.search);

        if (params) {
            Object.keys(params).forEach((key: string) => {
                const value = params[key];

                if (key === "token") {
                    gameiomModel.sessionToken = value;
                } else if (key === "username") {
                    gameiomModel.username = value;
                } else if (key === "language") {
                    gameiomModel.language = value.split(" ").join("");
                    settingsModel.language = value.split("-")[0];
                } else if (key === "currency") {
                    gameiomModel.currency = value;
                } else if (key === "gameId") {
                    gameiomModel.gameId = parseInt(value);
                } else if (key === "operatorId") {
                    gameiomModel.operatorId = parseInt(value);
                } else if (key === "providerId") {
                    gameiomModel.providerId = parseInt(value);
                } else if (key === "home_url") {
                    SettingsModel.homeURL = value;
                } else if (key === "callbackUrl") {
                    gameiomModel.callbackUrl = value;
                } else if (key === "playMode") {
                    if (value === "real") {
                        SettingsModel.playMode = RealityMode.REAL;
                    } else {
                        SettingsModel.playMode = RealityMode.FREE;
                    }
                } else if (key === "jurisdiction") {
                    gameiomModel.jurisdiction = value;
                } else if (key === "displayType") {
                    // not overriding if set yet
                    if (!gameiomModel.displayCurrency) {
                        gameiomModel.displayCurrency = value === "currency";
                    }
                } else if (key === "platformServer") {
                    gameiomModel.url = value;
                }
            });
        }
    }

    private loadGameiomConfig() {
        const query = "gameiom-config.json";

        return new Contract<string>((resolve) => {
            axios.get(query).then((response: any) => {

                this.gameiomConfig = response.data as GameiomConfig;

                resolve();
            });
        });
    }

    private updateWrapperWithStake() {
        gameWrapper.stakeUpdate(BetModel.getTotalStake());
    }

    private setupPreloaderDisclaimer() {
        for (const jurisdiction in this.gameiomConfig.disclaimers) {
            if (this.gameiomConfig.disclaimers.hasOwnProperty(jurisdiction)) {
                if (gameiomModel.jurisdiction && gameiomModel.jurisdiction.toString() === jurisdiction) {
                    Loader.minPreloaderTime = 5000;
                    Layers.Menus.onSceneEnter.add((sceneName: string) => {
                        if (sceneName === "preloader") {
                            const disclaimer = Layers.Menus.getText("disclaimer");
                            if (disclaimer) {
                                disclaimer.text = this.gameiomConfig.disclaimers[jurisdiction];
                            }
                        }
                    });
                    return;
                }
            }
        }

        // Operators without a disclaimer should hide the text
        Layers.Menus.onSceneEnter.add((sceneName: string) => {
            if (sceneName === "preloader") {
                const disclaimer = Layers.Menus.getText("disclaimer");
                if (disclaimer) {
                    disclaimer.visible = false;
                }
            }
        });
    }

    // Stop on feature win should always be on in UK jurisdiction
    private setupStopOnFeatureJurisdiction() {
        if (gameiomModel.jurisdiction && gameiomModel.jurisdiction.toString().toLowerCase() === "uk" || gameiomModel.autoplay && !gameiomModel.autoplay.stopOnFeatureWin) {
            // Remove stop on feature win control
            ControlList.getAllControls().forEach((controlDefinition, index) => {
                if (controlDefinition.assetName === "stop_on_feature_win_toggle") {
                    ControlList.getAllControls().splice(index, 1);
                }
            });

            // Hide assets for stop on feature win
            Layers.MenusContent.onSceneEnter.add(() => {
                const toggle = Layers.MenusContent.getToggle("stop_on_feature_win_toggle");
                const labelText = Layers.MenusContent.getText("[lbl.FIW]");

                if (toggle) {
                    toggle.setVisible(false);
                    labelText.visible = false;
                }
            });

            // Set stop on feature win to always be true
            autoplayModel.stopOnFeatureWin = true;
        }
    }
}

export default new Gameiom();
